module.exports = __webpack_public_path__ + "img/pef_investment_overview_icon02.13c139af.svg";